var map = {
	"./labmemtest_title_en.png": "95d4",
	"./labmemtest_title_jp.png": "0b63",
	"./labmemtest_title_kr.png": "d689",
	"./labmemtest_title_sc.png": "1dc6",
	"./labmemtest_title_tc.png": "d403"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "11d9";